export default __webpack_public_path__ + "static/media/ic_person_add_48px.3b1ab950.svg";